import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { Button, Dropdown, Modal } from "react-bootstrap";

import TableComponent from "../TableComponent";
import { URLS } from "../urls";
import {
  arrangeEventObject,
  fetchActionsUtil,
  stringifyQueryObjects,
  useCookie,
} from "../../utils";
import ModalLoader from "../ModalLoader";
import { ExcelIcon, ExportIcon } from "../icons";
import { CSVLink } from "react-csv";
import { useDownloadExcel } from "../useDownloadExcel";
import RsDateRangePicker from "../RsDateRangePicker";
import { CalendarTodayOutlined } from "@mui/icons-material";
import { UseQueryData } from "../UseQueryData";
// import { EditAttendance } from "./EditAttendance";

export default function DisplaySingleRoster({
  setShowDisplaySingle,
  UserId,
  noneSaveEntries,
  showSaveButton,
  startDate,
  endDate,
}) {
  const branch_id = useCookie("branch_id");
  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 31,
    page: 1,
    id: "",
    startDate: startDate
      ? moment(startDate).subtract(1, "hour").toISOString()
      : "",
    endDate: endDate ? moment(endDate).subtract(1, "hour").toISOString() : "",
  };
  const { queryParams, theQueryParams, onChangeInput } = UseQueryData({
    initialQueryParams,
    timer: 1500,
  });
  // ------------------ Filter Search -------------------//

  const [showAttendance, setShowAttendence] = useState({});
  const [loading, setLoading] = useState(false);

  const [editDetails, setEditDetails] = useState({
    open: false,
    employeeName: "",
    employeeID: "",
    date: "",
  });

  const [excelData, setExcelData] = useState([]);

  const CSVLinkRef = useRef(null);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  useEffect(() => {
    if (showSaveButton) {
      arrangeNonSavedEntries();
    } else {
      getAttendance();
    }
  }, [showSaveButton, UserId, queryParams]);

  const tableHead = () => {
    return (
      <thead>
        <tr>
          <th></th>
          <th>No</th>
          <th>Employee Name </th>
          <th>Employee ID </th>
          <th>Date </th>
          <th>Time In</th>
          <th>Time Out</th>
        </tr>
      </thead>
    );
  };

  const tableBodyData = (attendance, index) => {
    const dateMoment = moment(attendance?.Date);
    return (
      <>
        <td className="text-right">
          {!showSaveButton ? (
            <Dropdown>
              <Dropdown.Toggle variant="" bsPrefix="">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu
                popperConfig={{
                  strategy: "fixed",
                }}
                renderOnMount
                className="text-center"
              >
                <Dropdown.Item
                  as="div"
                  className="p-cursor"
                  onClick={() =>
                    setEditDetails((prev) => ({
                      employeeName: attendance.Name,
                      open: true,
                      employeeID: attendance.ID,
                      date: attendance?.Date,
                    }))
                  }
                >
                  <i className="fa fa-pencil m-r-5"></i> Edit
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null}
        </td>
        <td>{index + 1}</td>
        <td>{attendance.Name}</td>
        <td>{attendance.ID}</td>

        <td className="d-flex gap-3 align-items-center">
          {" "}
          <span>
            {" "}
            <CalendarTodayOutlined fontSize="small" />{" "}
          </span>{" "}
          <span>{dateMoment?.format("dddd")},</span>
          <p>{dateMoment?.format("MMMM Do YYYY")}</p>{" "}
        </td>
        <td>{attendance.TimeIn}</td>
        <td>{attendance.TimeOut}</td>
      </>
    );
  };

  const arrangeNonSavedEntries = () => {
    const currentUser = noneSaveEntries?.filter((item) => item?.ID === UserId);
    setShowAttendence(currentUser);
  };

  const getAttendance = async () => {
    try {
      setLoading(true);

      const result = await fetchActionsUtil(
        `${URLS.backendRosterPlanning}/get/${branch_id}?${stringifyQueryObjects(
          {
            ...queryParams,
            id: UserId,
          }
        )}`
      );

      setShowAttendence(result?.attendance || []);
    } catch (error) {
      console.log(error);
      toast("Unable to get TimeSheet", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const onDownloadExcelData = async () => {
    let exData = showAttendance?.map((attendance, index) => [
      index + 1,
      attendance.Name,
      attendance.ID,
      moment(attendance?.Date)?.format("MM/DD/YYYY"),
      attendance.in,
      attendance.out,
    ]);

    const normalHead = ["No", "Name", "ID", "Date", "In-Time", "Out-Time"];

    const date = `Date Prepared: ${moment(new Date()).format(
      "MMMM DD yyyy k:mm:ss z"
    )}`;

    exData = [
      // [company],
      ["Roster Report"],
      [date],
      [""],
      normalHead,
      ...exData,
      [""],
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  const filterByDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: picker.startDate,
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: picker.endDate,
      })
    );

    picker.element.val(
      picker.startDate.format("DD-MM-yyyy") +
        " - " +
        picker.endDate.format("DD-MM-yyyy")
    );
  };

  const clearDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: "",
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: "",
      })
    );

    picker.element.val("");
  };

  return (
    <Modal
      centered
      show={true}
      onHide={() => {
        setShowDisplaySingle();
      }}
      className="custom-modal"
      size="lg"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="form-header">
          <div className="d-flex justify-content-between align-items-baseline">
            <div>
              <p className=" text-16 light-text font-500">
                Employee ID : {UserId}
              </p>
            </div>

            <div className=" d-flex align-items-center">
              <div className="mx-4">
                <RsDateRangePicker
                  placement="topEnd"
                  className="form-control-w-0 w-100"
                  onClean={(event, picker) => clearDateRange(event, picker)}
                  onOk={(event, picker) => filterByDateRange(event, picker)}
                />
              </div>

              <div>
                <CSVLink
                  className="btn print d-none"
                  filename={`Attendance Report(${moment(new Date()).format(
                    "DD-MMM-yyyy hh:mm:ss a"
                  )}).csv`}
                  data={excelData}
                  ref={CSVLinkRef}
                />

                <Dropdown>
                  <Dropdown.Toggle
                    variant=""
                    className="print"
                    disabled={isfetchingExcel}
                    bsPrefix=""
                  >
                    <span className="mx-2 text-12">Export</span>
                    <ExportIcon fontSize="12px" color="#008000" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    popperConfig={{
                      strategy: "fixed",
                    }}
                    renderOnMount
                    className="text-center"
                  >
                    <Dropdown.Item
                      as="div"
                      onClick={onDownloadExcelData}
                      className="p-cursor"
                    >
                      Excel <ExcelIcon color="#008000" />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          {/*<!-- JobGradeHistory Table -->*/}
          <div className="info">
            <div className="table-height">
              {showAttendance?.length > 0 && (
                <TableComponent
                  responsive
                  borderless
                  striped
                  sticky
                  // hover
                  tableHeadsFunction={tableHead}
                  mainDataArray={showAttendance}
                  tableDataRowFunction={tableBodyData}
                  className="product-table text-nowrap"
                />
              )}
            </div>
          </div>
          {/*<!-- Table --> */}
          <ModalLoader show={loading} />
        </div>
        <hr />
      </Modal.Body>

      {/* {editDetails.open ? (
        <EditAttendance
          show={editDetails.open}
          handleClose={() =>
            setEditDetails((prev) => ({ ...prev, open: false }))
          }
          details={editDetails}
          reload={getAttendance}
        />
      ) : null} */}
    </Modal>
  );
}
